import { useQuery } from '@tanstack/react-query'

export const MARKET_MAKER_BASE_URL = 'https://dextoro-market-maker-production.up.railway.app'
const HEALTH_URL = `${MARKET_MAKER_BASE_URL}/health`

export interface MarketMakerHealth {
  status: string                  // 'ok' on healthy
  uptime_seconds: number
  timestamp: string               // ISO string
  websocket_connected: boolean    // false ⇒ degraded (cluster needs WS for prices)
  active_configs: number          // active mm configs
  total_trades_executed: number
  last_trade_at: string | null    // ISO string or null on cold start
  active_trades: number           // in-flight trades right now
  fetchedAt: number               // appended client-side
}

/**
 * Polls dextoro-market-maker /health every 30s. Throws on non-2xx so the
 * useQuery error state surfaces in BackendServicesSection.
 *
 * Source of truth for the response shape:
 * dextoro-market-maker/src/index.ts:54-68
 */
export function useMarketMakerHealth() {
  return useQuery({
    queryKey: ['market-maker-health'],
    queryFn: async (): Promise<MarketMakerHealth> => {
      const res = await fetch(HEALTH_URL)
      if (!res.ok) throw new Error(`Health endpoint returned ${res.status}`)
      const data = await res.json()
      return { ...data, fetchedAt: Date.now() }
    },
    staleTime: 15_000,
    refetchInterval: 30_000,
  })
}
